import { i18n } from '@/locales';
const storeDetailLc = 'views.store_management_detail.';
export default {
    // 기본료 (월충전, 월정액, 건당)
    DELIVERY_FEE_MONTHLY: {
        key: 'deliveryFeeMonthly',
        text: {
            MONTHLY_CHARGE: i18n.t(`${storeDetailLc}base_fee`),
            MONTHLY_FIXED_AMOUNT: i18n.t(`${storeDetailLc}base_fee`),
            PER_CASE: i18n.t(`${storeDetailLc}base_fee`),
        },
        value: 'formattedDeliveryFeeMonthly',
        isShow: [
            'MONTHLY_CHARGE',
            'MONTHLY_FIXED_AMOUNT',
            'PER_CASE',
        ],
    },
    // 청구 시작일 (월충전) / 납입일 (월정액, 건당)
    DELIVERY_FEE_MONTHLY_DAY: {
        key: 'deliveryFeeMonthlyDay',
        text: {
            MONTHLY_CHARGE: i18n.t(`${storeDetailLc}billing_start_date`),
            MONTHLY_FIXED_AMOUNT: i18n.t(`${storeDetailLc}payment_date`),
            PER_CASE: i18n.t(`${storeDetailLc}payment_date`),
        },
        value: 'formattedDeliveryFeeMonthlyDay',
        isShow: [
            'MONTHLY_CHARGE',
            'MONTHLY_FIXED_AMOUNT',
            'PER_CASE',
        ],
    },
    // 월 충전 건수 (월충전),
    END_DELIVERY_COUNT: {
        key: 'endDeliveryCount',
        text: {
            MONTHLY_CHARGE: i18n.t(`${storeDetailLc}number_of_monthly_charges`),
        },
        value: 'formattedEndDeliveryCount',
        isShow: [
            'MONTHLY_CHARGE',
        ],
    },
    // 월 충전 접수 불가 (월충전)
    IS_MONTHLY_CHARGE_UNACCEPT_YN: {
        key: 'isMonthlyChargeUnAccept',
        text: {
            MONTHLY_CHARGE: i18n.t(`${storeDetailLc}monthly_charge_acceptability`),
        },
        value: 'formattedIsMonthlyChargeUnAccept',
        isShow: [
            'MONTHLY_CHARGE',
        ],
    },
    // 건당관리비 (건당)
    DELIVERY_MANEGEMENT_FEE: {
        key: 'deliveryManagementFee',
        text: {
            PER_CASE: i18n.t(`${storeDetailLc}delivery_management_fee`),
        },
        value: 'formattedDeliveryManagementFee',
        isShow: [
            'PER_CASE',
        ],
    },
    // 관리비 부가세 (월충전, 월정액, 건당)
    VAT_RATE_MONTHLY: {
        key: 'vatRateMonthly',
        text: {
            MONTHLY_CHARGE: i18n.t(`${storeDetailLc}vat_rate_montly`),
            MONTHLY_FIXED_AMOUNT: i18n.t(`${storeDetailLc}vat_rate_montly`),
            PER_CASE: i18n.t(`${storeDetailLc}vat_rate_montly`),
        },
        value: 'formattedVatRateMonthly',
        isShow: [
            'MONTHLY_CHARGE',
            'MONTHLY_FIXED_AMOUNT',
            'PER_CASE',
        ],
    },
};
